<template>
  <component
    :is="elementComponent"
    class="absolute-cover z-[10000]"
    :surface="surface"
    :element="element"
    :initiating-event="initiatingEvent"
    :data-element-id="element.id"
  />
</template>

<script setup>

  import {
    SurfaceEditorElementEditImage,
    SurfaceEditorElementEditText,
    SurfaceEditorElementEditShape
  } from '#components';

  const props = defineProps({
    element: Object,
    surface: Object,
    initiatingEvent: Object
  });

  const elementComponent = computed(() => {
    switch (props.element.type) {
      case SURFACE_EDITOR_ELEMENT_TYPE.image:
        return SurfaceEditorElementEditImage;
      case SURFACE_EDITOR_ELEMENT_TYPE.text:
        return SurfaceEditorElementEditText;
      // case SURFACE_EDITOR_ELEMENT_TYPE.shape:
      //   return SurfaceEditorElementEditShape;

    }
  });

</script>

